
<div class="contents">
  <div class="logo">
    <a style="margin-left: 35px;" class="simple-text logo-mini">
      <div class="logo-img photo">
          <img src="/assets/logo/logo-imagen.png"/>
      </div>
    </a>
      <a [routerLink]="['/home']" class="simple-text logo-normal" 
        style="max-width: 148px; text-align: left;">
        <!-- ATP -->
        <img src="/assets/logo/logo3.png" style="max-width: 142px; max-height: 40px;"/>
      </a>
  </div>


  <div class="sidebar-wrapper">
    <div class="user">
      <div class="photo" style="width: auto; height: auto;">
          <!-- <img src="./assets/images/user.png" /> -->
          <i class="material-icons" style="font-size: -webkit-xxx-large; color: white;">
            person_pin</i>
      </div>
      <div class="user-info">
          <a data-toggle="collapse" href="#collapseExample" class="collapsed">
              <span> 
                  {{user.nombres}} {{user.apellidos}}
                  <p style="font-size: 12px;font-weight: bold;margin-bottom: 0;" *ngIf="user.rol">
                    ({{user.rol.nombre}})
                  </p>
                  <b class="caret"></b>
              </span>
          </a>
          <div class="collapse" id="collapseExample">
              <ul class="nav">
                  <li class="nav-item">
                      <a [routerLink]="['/userinfo']" class="nav-link">
                          <i class="material-icons">person</i>
                          <span class="sidebar-normal">Perfil de usuario</span>
                      </a>
                  </li>
                  <!-- <li class="nav-item">
                      <a [routerLink]="['/agenda']" class="nav-link">
                          <i class="material-icons">contacts</i>
                          <span class="sidebar-normal">Contactos</span>
                      </a>
                  </li> -->
                  <!-- <li class="nav-item">
                      <a [routerLink]="['/see-payments']" class="nav-link">
                          <i class="material-icons">request_page</i>
                          <span class="sidebar-normal">Ordenes de pago</span>
                      </a>
                  </li> -->
              </ul>
          </div>
      </div>
    </div>

    <!-- <div *ngIf="isMobileMenu()"> -->
      <!-- <form class="navbar-form">
        <span class="bmd-form-group"><div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div></span>
      </form>
      <ul class="nav navbar-nav nav-mobile-menu">
        <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="material-icons">dashboard</i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li> -->

        <!-- <li class="nav-item dropdown">
          <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">notifications</i>
            <span class="notification">5</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" href="#">Mike John responded to your email</a>
            <a class="dropdown-item" href="#">You have 5 new tasks</a>
            <a class="dropdown-item" href="#">You're now friend with Andrew</a>
            <a class="dropdown-item" href="#">Another Notification</a>
            <a class="dropdown-item" href="#">Another One</a>
          </div>  
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="material-icons">person</i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>
      </ul> -->
    <!-- </div> -->

    <ul class="nav">
      <li routerLinkActive="active" class="nav-item">
        <a class="nav-link" [routerLink]="['/home']">
          <i class="material-icons">home</i>
          <p>Inicio</p>
        </a>
      </li>

      <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
        <!--If is a single link-->
        <a [routerLink]="[menuitem?.path]" *ngIf="menuitem?.type === 'link'; else showSubmenu" class="nav-link">
            <i class="material-icons">{{menuitem?.icontype}}</i>
            <p>{{menuitem?.title}}</p>
        </a>
        <ng-template #showSubmenu>
          <!--If it have a submenu-->
          <a data-toggle="collapse" href="#{{menuitem.collapse}}" (click)="updatePS()" class="nav-link">
            <i class="material-icons">{{menuitem.icontype}}</i>
            <p>{{menuitem?.title}}<b class="caret"></b></p>
          </a>
        </ng-template>

        <!--Display the submenu items-->
        <div id="{{menuitem?.collapse}}" class="collapse" *ngIf="menuitem?.type === 'sub'">
          <ul class="nav" *ngIf="menuitem.children">
            <li routerLinkActive="active" *ngFor="let childitem of menuitem?.children" class="nav-item">
                <a [routerLink]="[childitem.path]" class="nav-link">
                    <i class="material-icons">{{childitem.icon}}</i>
                    <span class="sidebar-normal">{{childitem.title}}</span>
                </a>
            </li>
          </ul>
        </div>

      </li>

      <li class="nav-item">
        <a style="cursor: pointer;" class="nav-link" (click)="cerrarSesion()">
          <i class="material-icons">logout</i>
          <p>Cerrar Sesión</p>
        </a>
      </li>

    </ul>

  </div>
</div>